import main from '../main'
/**
 * Different custom validators for 'vee-validate' plugin {@see main}
 */
const emailValidation = function (value) {
  /* eslint no-useless-escape: "error" */
  if (!value) {
    return false
  }
  const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  value = String(value).trim()
  return new RegExp(pattern).test(value)
}

const emptyValidation = function (value) {
  if (!value) {
    return false
  }
  value = value.toString().trim()
  return value !== ''
}

const emailListValidator = function (value) {
  if (!value) {
    return false
  }
  value = String(value)
  if (value.includes(',')) {
    const emails = value.split(',')
    return emails.every(email => emailValidation(email))
  } else return emailValidation(value)
}

export default {
  emailValidation,
  emptyValidation,
  emailListValidator
}
